import { ArrowRight } from '@/assets';
import staticStyles from './animateLinkText.module.scss';

interface AnimateLinkTextProps {
  text: string;
  styles: string;
}

export const AnimateLinkText = ({ text, styles }: AnimateLinkTextProps) => {
  return (
    <div className={`${staticStyles.link_text} ${styles}`}>
      <div className={`${staticStyles.text_wrapper} `}>
        <span>{text}</span>
        <span>{text}</span>
      </div>
      <ArrowRight />
    </div>
  );
};
